<template>
  <section class="-wrapper-tile feature- -summary-grid s2">
    <div class="-wrapper-column -width-100 -border-radius-1">
      <div class="-header">
        <p class="-h2 -font-weight-medium">{{ $t('pages_contract_ContractInfo.totalTradeAmountByKrw') }}</p>
      </div>
      <div class="-wrapper-v-center between- -px-5 -pt-5">
        <p class="-font-size-14 -font-weight-medium">{{ $t('pages_contract_ContractInfo.total') }}</p>
        <p class="-font-size-24 -font-family-special" id="contract-detail-totalCost">₩{{ contractSummary.totalCost }}</p>
      </div>
      <div class="-wrapper between- -px-5">
        <time class="-description">{{ contractSummary.invoiceMonth }}</time>
        <p class="-description" id="contract-detail-description">{{ $t('pages_contract_ContractInfo.includeVat') }}</p>
      </div>

      <div class="-mt-5 -px-5">

        <div class="-width-100;" style="height: 209px; overflow-y: auto;">
          <div v-for="(item, index) in contractMonth" :key="item.contractName + index">
            <div class="-wrapper between- -mt-3 line-height-20">
              <p class="-color-blue-1 -font-size-12 line-height-20 -ellipsis" style="width: 70%;" >
                <a :id="'contract-info-list-grid-bs-click_'+item.id" class="link-" v-if="auth ==='BS'" href="#"  @click="onClickContractIdSelect(item.id,item.employeeCode)" >{{ item.contractName }} </a>
                <a :id="'contract-info-list-grid-am-click_'+item.id" class="link-" v-else-if="auth ==='AM'" href="#"  @click="onClickContractIdSelect(item.id,item.customerCode+item.deptCode)" >{{ item.contractName }}</a>
                <a :id="'contract-info-list-grid-pa-click_'+item.id" class="link-" v-else href="#"  @click="onClickContractIdSelect(item.id)" >{{ item.contractName }}</a>
              </p>
              <p class="-color-gray-1 -font-size-12 line-height-20 -pr-1" id="contract-detail-totalTradeAmountByKrw" >₩{{ item.totalTradeAmountByKrw }}</p>
            </div>
          </div>

        </div>

      </div>
      <div class="-wrapper -px-5 -pt-4">
      </div>
    </div>
  </section>
</template>

<script>

import {mapActions, mapGetters} from 'vuex'
import {DEFAULT_PAGE_SIZE,AUTH_GROUP} from '@/constants/constants';
import moment from "moment";

export default {

  data() {
    return {
      perPage: DEFAULT_PAGE_SIZE,
      auth : '',
    }
  },
  computed: {
    ...mapGetters('contract', ['contractSummary','contractMonth']),
    ...mapGetters('user', ['userInfo']),


  },
  methods: {
    onClickContractIdSelect(id,empNo){

      let date = new Date();
      let month = moment(date.getTime()).add("-1", "M").format("YYYYMM");
      if(this.userInfo.auth === AUTH_GROUP.BespinSales) {
        this.$router.push(`/contract/detail?id=${id}&companyCode=${this.userInfo.companyCode}&month=${month}&empNo=${empNo}`)
      }else  if(this.userInfo.auth === AUTH_GROUP.AccountManager){
        this.$router.push(`/contract/detail?id=${id}&companyCode=${this.userInfo.companyCode}&month=${month}&customerCode=${empNo}`)
      }else{
        this.$router.push(`/contract/detail?id=${id}&companyCode=${this.userInfo.companyCode}&month=${month}`)
      }

    },

  },

  beforeMount() {
    this.auth =this.userInfo.auth
  },

}
</script>



// WEBPACK FOOTER //
// src/pages/contract/components/ContractInfoCostLastMonth.vue